var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocketIo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0699 1.15346C20.1116 -0.139506 25.6838 0.613932 30.1302 3.35815C35.7302 6.70706 39.3861 13.0419 39.4791 19.5628C39.6838 26.1488 36.2511 32.6791 30.7349 36.2605C24.5953 40.3907 16.1024 40.5489 9.83251 36.6233C3.44189 32.8092 -0.288426 25.1163 0.669855 17.7302C1.44173 9.9255 7.46985 3.0419 15.0699 1.15362V1.15346Z",
    fill: "#010101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2977 4.3442C23.8233 0.530141 35.507 7.57201 36.493 17.7861C38.028 26.9767 30.4 36.3162 21.0883 36.5861C12.2325 37.4698 3.67438 29.9626 3.42329 21.0698C2.76282 13.8698 7.50704 6.72561 14.2977 4.3442Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2558 19.0141C19.5256 15.5256 23.7023 11.9162 28.0652 8.53015C25.7767 12.0466 23.4233 15.5162 21.1348 19.0325C19.172 19.0419 17.2094 19.0419 15.2558 19.0139V19.0141ZM18.8652 20.9581C20.8372 20.9581 22.8 20.9581 24.7628 20.9861C20.4652 24.4558 16.307 28.093 11.9348 31.4698C14.2233 27.9534 16.5767 24.4745 18.8652 20.9581Z",
    fill: "#010101"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocketIo);
export default __webpack_public_path__ + "static/media/socket-io.07b12d1d1ce17aecfe0b7e02f5d57368.svg";
export { ForwardRef as ReactComponent };